import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { HoverBorderGradient } from "../../ui/hover-border-gradient";
import {
  ArrowRight,
  ArrowUpRight,
  Award,
  BadgeCheck,
  BarChart,
  CircleUserRound,
  Cpu,
  Database,
  Globe,
  LineChart,
  Monitor,
  Shield,
} from "lucide-react";
import { Grid } from "../../ui/Grid";
import { PinContainer } from "../../ui/3d-pin";
import { motion } from "framer-motion";
import {
  downAndUp,
  scrollVariantsLeft,
  scrollVariantsRight,
  upAndDown,
} from "../../../constants/TextAnimation";
import { avatar5, avatar2, avatar4 } from "../../../assets";
import RadialOrbitalTimelineDemo from "./RadialOrbitalTimeLineDemo";
import GoogleGeminiEffectDemo from "../../animation/GoogleGeminiEffectDemo";
import BusinessSetUp from "./BusinessSetUp";

const Home = () => {
  const services = [
    {
      title: "Business immigration",
      description:
        "Transform your data into actionable insights with our advanced analytics solutions.",
      icon: <LineChart className="h-8 w-8" />,
    },
    {
      title: "Advisory services",
      description:
        "Secure, scalable cloud infrastructure and migration services for modern businesses.",
      icon: <Database className="h-8 w-8" />,
    },
    {
      title: "CFO Services",
      description:
        "Protect your business with comprehensive security solutions and proactive monitoring.",
      icon: <Shield className="h-8 w-8" />,
    },
    {
      title: "Global Business Setup",
      description:
        "Custom software solutions designed to meet your unique business requirements.",
      icon: <Monitor className="h-8 w-8" />,
    },
  ];
  return (
    <>
      <section className="py-10 sm:py-16 lg:py-15 h-[80vh] md:h-[90vh] bg-gradient-to-br from-gold/10 to-transparent">
        {/* Hero */}
        <div className="relative overflow-hidden before:absolute before:top-0 before:start-1/2 before:bg-[url('/images/solutions/polygon-bg-element.svg')] before:bg-no-repeat before:bg-top before:bg-cover before:size-full before:-z-1 before:transform before:-translate-x-1/2 before:invert before:z-[-1]">
          <div className="max-w-[85rem] mx-auto px-4 sm:px-6 pt-20 lg:px-8 lg:pt-40 pb-10">
            {/* Announcement Banner */}
            {/* <div className="flex justify-center">
              <Link
                className="inline-flex items-center gap-x-2 bg-white border border-gray-200 text-sm text-gray-800 p-1 ps-3 rounded-full transition hover:border-gray-300 focus:outline-hidden focus:border-gray-300"
                href="#"
              >
                Solutions - Join to waitlist
                <span className="py-1.5 px-2.5 inline-flex justify-center items-center gap-x-2 rounded-full bg-gray-200 font-semibold text-sm text-gray-600">
                  <svg
                    className="shrink-0 size-4"
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="m9 18 6-6-6-6" />
                  </svg>
                </span>
              </Link>
            </div> */}
            {/* End Announcement Banner */}

            {/* Title */}
            <div className="mt-5 max-w-3xl text-center mx-auto">
              <h1 className="block font-bold text-gray-300 text-4xl md:text-4xl lg:text-5xl">
                {/* Your Global Business {""}
                <span className="bg-clip-text bg-gradient-to-tl from-gold via-gold to-gold text-transparent">
                  Experts
                </span> */}
                <ColourfulText text="Your Global Business Experts" />
              </h1>
            </div>
            {/* End Title */}

            <div className="mt-5 max-w-xl text-center mx-auto">
              <p className="text-lg text-gray-400">
                Unlocking Potential, Advancing Futures: Explore Our Expert
                Business and Financial Solutions
              </p>
            </div>

            {/* Buttons */}
            <div className="mt-8 gap-3 flex justify-center">
              <Link to="/solutions/contact">
                <HoverBorderGradient
                  containerClassName="rounded-full"
                  as="button"
                  className="group bg-white/5 backdrop-blur-md text-white font-semibold py-1.5 ps-5 pe-1.5 rounded-full hover:opacity-80 transition duration-200 inline-flex items-center gap-4 leading-normal space-x-2"
                >
                  Get Started
                  <span className="bg-white text-slate-900 p-2.5 rounded-full transition-transform duration-300 group-hover:rotate-[45deg]">
                    <ArrowUpRight size={18} />
                  </span>
                </HoverBorderGradient>
              </Link>
            </div>
            {/* End Buttons */}

            <div className="mt-5 flex flex-col sm:flex-row justify-center items-center gap-1.5 sm:gap-3">
              <div className="flex flex-wrap gap-1 sm:gap-3">
                <span className="text-sm text-gray-400">NOTE:</span>
                <span className="text-sm font-bold text-gray-300">
                  Scan Global Solutions
                </span>
              </div>
              <svg
                className="hidden sm:block size-5 text-gray-300"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
              >
                <path
                  d="M6 13L10 3"
                  stroke="currentColor"
                  strokeLinecap="round"
                />
              </svg>
              <a
                className="inline-flex items-center gap-x-1 text-sm text-gold decoration-2 hover:underline focus:outline-hidden focus:underline font-medium"
                href="solutions/what-we-do"
              >
                Explore Guide
                <svg
                  className="shrink-0 size-4"
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="m9 18 6-6-6-6" />
                </svg>
              </a>
            </div>
          </div>
        </div>
        {/* End Hero */}
      </section>

      {/* our services */}
      <section className="pb-10 md:pb-16 lg:pb-14 pt-10 md:pt-16 lg:pt-20">
        <div className="container mx-auto px-4 relative z-10">
          <div className="max-w-3xl mx-auto mb-12 text-center">
            <h3 className="text-gold font-semibold text-sm uppercase tracking-wide mb-1">
              OUR SERVICES
            </h3>
            <h2 className="text-3xl font-bold sm:text-4xl mb-4">What We Do</h2>
            <p className="text-gray-400 text-lg">
              We offer a comprehensive range of technology services to help your
              business thrive in the digital landscape.
            </p>
          </div>

          <motion.div
            variants={downAndUp}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.3 }}
            className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8"
          >
            {services.map((service, index) => (
              <div
                key={index}
                className="bg-gray-600/20 rounded-lg shadow-lg p-6 transition-all duration-300 hover:shadow-xl hover:-translate-y-1 group"
              >
                <div className="w-16 h-16 rounded-lg bg-gold/10 flex items-center justify-center text-gold mb-6">
                  {service.icon}
                </div>
                <h3 className="text-xl font-bold mb-3">{service.title}</h3>
                <p className="text-gray-400 mb-4">{service.description}</p>
                {/* Optional Learn More button here */}
              </div>
            ))}
          </motion.div>

          <motion.div
            variants={downAndUp}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.3 }}
            className="text-center mt-12"
          >
            <Link
              to="/solutions/what-we-do"
              className="bg-gold py-2 px-4 rounded-full text-slate-900 inline-flex items-center gap-2 font-semibold hover:bg-gold/80 transition duration-200"
            >
              View All Services{" "}
              <ArrowRight size={17} className="text-slate-900" />
            </Link>
          </motion.div>
        </div>
      </section>

      <section className="pb-20 md:pt-16 pt-5">
        <div className="container mx-auto px-4">
          <div className="max-w-md mx-auto mb-4 md:mb-122 text-center ">
            <h2 className="text-3xl font-bold md:text-5xl md:mb-4">
              Empowering Your <span className="text-gold">Future</span>
            </h2>
          </div>
          <div className="flex flex-wrap items-center mt-1 md:mt-0 ">
            {/* <div className="w-full md:w-5/12 px-4 mr-auto ml-auto mb-8 md:mb-0">
              <div className="relative overflow-hidden flex flex-col min-w-0 break-words bg-slate-900/50 w-full mb-6 shadow-lg rounded-lg p-8">
                <Grid size={25} />
                <blockquote className="relative">
                  <h4 className="text-xl font-bold text-white">
                    Leading the Digital Transformation
                  </h4>
                  <p className="text-md font-light mt-2 text-white">
                    At Scan Global Solutions, we're committed to helping
                    businesses navigate the complexities of digital
                    transformation. Our expert team delivers tailored solutions
                    that drive growth and innovation.
                  </p>
                </blockquote>
              </div>
            </div> */}

            {/* <motion.div
              variants={scrollVariantsLeft}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.5 }}
              className="h-[25rem] w-full md:w-5/12 px-4 m-auto mb-8 md:mb-0"
            >
              <PinContainer title="Scan Global Solutions" href="#"> */}
            <div className="flex basis-full flex-col my-10 md:my-0 p-4 tracking-tight text-slate-100/50 sm:basis-1/2 w-[20rem] h-[18rem] justify-center items-center">
              <h3 className="max-w-xs md:pt-12 !pb-2 !m-0 font-bold  text-base text-slate-100">
                Scanglobal Solutions
              </h3>
              <div className="text-base !m-0 !p-0 font-normal">
                <span className="text-slate-400 font-semibold">
                  Why Choose Us ?
                </span>
                {/* <ul>
                      <li className="inline-flex items-center gap-2">
                        <BadgeCheck size={16} className="text-gold" />
                        Commitment to Innovation
                      </li>
                      <li className="inline-flex items-center gap-2">
                        <BadgeCheck size={16} className="text-gold" />
                        Tailored Client Solutions
                      </li>
                      <li className="inline-flex items-center gap-2">
                        <BadgeCheck size={16} className="text-gold" />
                        Global Market Expertise
                      </li>
                    </ul> */}
              </div>
              {/* <div className="flex flex-1 w-full rounded-lg mt-4 bg-gradient-to-br from-violet-500 via-purple-500 to-blue-500" /> */}
              <div className="flex justify-center">
                <img
                  src="/images/solutions/1.jpg"
                  alt="img"
                  className="h-[300px] object-cover border-2 border-white p-1 rounded-lg mt-4"
                />
              </div>
            </div>
            {/* </PinContainer>
            </motion.div> */}

            <motion.div
              variants={scrollVariantsRight}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.3 }}
              className="w-full md:w-6/12 px-4 mr-auto ml-auto"
            >
              <div className="flex flex-wrap">
                <div className="w-full md:w-6/12 ">
                  <div className="relative flex flex-col mt-6 md:mt-24">
                    <div className="px-4 py-5 flex-auto">
                      <div className="text-gold p-3 text-center inline-flex items-center justify-center w-12 h-12 mb-5 shadow-lg rounded-full bg-gold/10">
                        <Globe className="w-6 h-6" />
                      </div>
                      <h6 className="text-xl mb-1 font-semibold">
                        Commitment to Innovation
                      </h6>
                      <p className="mb-4 text-gray-600">
                        Serving clients across continents with localized
                        expertise and global standards.
                      </p>
                    </div>
                  </div>
                  <div className="relative flex flex-col min-w-0">
                    <div className="px-4 py-5 flex-auto">
                      <div className="text-gold p-3 text-center inline-flex items-center justify-center w-12 h-12 mb-5 shadow-lg rounded-full bg-gold/10">
                        <Award className="w-6 h-6" />
                      </div>
                      <h6 className="text-xl mb-1 font-semibold">
                        Tailored Client Solutions
                      </h6>
                      <p className="mb-4 text-gray-600">
                        Award-winning solutions with a track record of client
                        success.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="w-full md:w-6/12 ">
                  <div className="relative flex flex-col min-w-0 mt-4 md:mt-24">
                    <div className="px-4 py-5 flex-auto">
                      <div className="text-gold p-3 text-center inline-flex items-center justify-center w-12 h-12 mb-5 shadow-lg rounded-full bg-gold/10">
                        <Cpu className="w-6 h-6" />
                      </div>
                      <h6 className="text-xl mb-1 font-semibold">
                        Global Market Expertise
                      </h6>
                      <p className="mb-4 text-gray-600">
                        Leveraging the latest technologies to deliver innovative
                        solutions.
                      </p>
                    </div>
                  </div>
                  <div className="relative flex flex-col min-w-0">
                    <div className="px-4 py-5 mt-10">
                      {/* <div className="text-gold p-3 text-center inline-flex items-center justify-center w-12 h-12 mb-5 shadow-lg rounded-full bg-gold/10">
                        <BarChart className="w-6 h-6" />
                      </div>
                      <h6 className="text-xl mb-1 font-semibold">
                        Measurable Results
                      </h6>
                      <p className="mb-4 text-gray-600">
                        Data-driven approach that delivers tangible business
                        outcomes.
                      </p> */}

                      <Link
                        to="/solutions/what-we-offer"
                        className="bg-gradient px-6 py-3 text-nowrap text-base rounded-full text-center font-medium cursor-pointer border border-slate-600 mt-10"
                      >
                        Learn more{" "}
                        <ArrowRight size={16} className="inline-block" />
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* <BusinessSetUp /> */}

      {/* golden card design */}
      <RadialOrbitalTimelineDemo />
      
      <GoogleGeminiEffectDemo />

      {/* Stats Section */}
      <section className="py-10 md:py-16 lg:py-20 bg-slate-900/50  with-lines-bg">
        <motion.div
          variants={downAndUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.3 }}
          className="container mx-auto px-4"
        >
          <div className="flex flex-wrap text-center justify-center relative z-10">
            <div className="w-full md:w-4/12 px-4 py-4">
              <div className="inline-flex mb-4 rounded-full bg-gold p-4">
                <Globe className="h-8 w-8 text-slate-900" />
              </div>
              <h3 className="text-4xl font-bold text-white">25+</h3>
              <p className="text-lg text-blue-200 mt-2">Countries Served</p>
            </div>
            <div className="w-full md:w-4/12 px-4 py-4">
              <div className="inline-flex mb-4 rounded-full bg-gold p-4">
                <Award className="h-8 w-8 text-slate-900" />
              </div>
              <h3 className="text-4xl font-bold text-white">500+</h3>
              <p className="text-lg text-blue-200 mt-2">
                global partners and clients
              </p>
            </div>
            <div className="w-full md:w-4/12 px-4 py-4">
              <div className="inline-flex mb-4 rounded-full bg-gold p-4">
                <Cpu className="h-8 w-8 text-slate-900" />
              </div>
              <h3 className="text-4xl font-bold text-white">98%</h3>
              <p className="text-lg text-blue-200 mt-2">satisfaction rate</p>
            </div>
          </div>
        </motion.div>
        <div className="text-center mt-12 relative z-10">
          <Link
            to="/solutions/what-we-do"
            className="bg-gold py-2 px-4 rounded-full text-slate-900 inline-flex items-center gap-2 font-semibold hover:bg-gold/80 transition duration-200"
          >
            Discover More
            <ArrowRight size={17} className="text-slate-900" />
          </Link>
        </div>
      </section>

      {/* testimonial */}
      <section className="py-10 md:py-16 lg:py-32">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto mb-12 text-center">
            <h3 className="text-gold font-semibold text-sm uppercase tracking-wide mb-1">
              TESTIMONIALS
            </h3>
            <h2 className="text-3xl font-bold sm:text-4xl mb-4">
              What Our Clients Say
            </h2>
            <p className="text-gray-400 text-lg">
              Don't just take our word for it. Hear from some of our satisfied
              clients.
            </p>
          </div>

          <motion.div
            variants={scrollVariantsRight}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.2 }}
            className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8"
          >
            <div className="bg-slate-900/50 rounded-lg shadow-lg p-8 relative">
              <div className="absolute -top-4 left-8 w-8 h-8 bg-gold text-slate-900 flex items-center justify-center text-xl font-serif rounded-full">
                &quot;
              </div>
              <blockquote className="mt-4">
                <p className="text-gray-400 text-lg leading-relaxed italic mb-6">
                  Scan Global Solutions transformed our business with their
                  cloud migration services. Their team was professional,
                  knowledgeable, and delivered on time and within budget.
                </p>
                <div className="flex items-center">
                  {/* <img
                    src={avatar4}
                    alt="user"
                    className="w-12 h-12 rounded-full object-cover mr-4"
                  /> */}
                  <CircleUserRound className="size-10 me-4 p-2 text-gold bg-gold/20 rounded-full" />
                  <div>
                    <div className="font-bold text-gray-400">Sarah Johnson</div>
                    <div className="text-gray-500 text-sm">
                      CTO, TechCorp Inc.
                    </div>
                  </div>
                </div>
              </blockquote>
            </div>
            <div className="bg-slate-900/50 rounded-lg shadow-lg p-8 relative">
              <div className="absolute -top-4 left-8 w-8 h-8 bg-gold text-slate-900 flex items-center justify-center text-xl font-serif rounded-full">
                &quot;
              </div>
              <blockquote className="mt-4">
                <p className="text-gray-400 text-lg leading-relaxed italic mb-6">
                  The cybersecurity solution implemented by Scan Global has
                  significantly improved our security posture. We've seen a 75%
                  reduction in security incidents since implementation.
                </p>
                <div className="flex items-center">
                  {/* <img
                    src={avatar2}
                    alt="user"
                    className="w-12 h-12 rounded-full object-cover mr-4"
                  /> */}
                  <CircleUserRound className="size-10 me-4 p-2 text-gold bg-gold/20 rounded-full" />
                  <div>
                    <div className="font-bold text-gray-400">Michael Chen</div>
                    <div className="text-gray-500 text-sm">
                      IT Director, Secure Systems
                    </div>
                  </div>
                </div>
              </blockquote>
            </div>
            <div className="bg-slate-900/50 rounded-lg shadow-lg p-8 relative">
              <div className="absolute -top-4 left-8 w-8 h-8 bg-gold text-slate-900 flex items-center justify-center text-xl font-serif rounded-full">
                &quot;
              </div>
              <blockquote className="mt-4">
                <p className="text-gray-400 text-lg leading-relaxed italic mb-6">
                  Working with Scan Global on our data analytics project was a
                  game-changer. Their insights helped us identify new market
                  opportunities and increase revenue by 30%.
                </p>
                <div className="flex items-center">
                  {/* <img
                    src={avatar5}
                    alt="user"
                    className="w-12 h-12 rounded-full object-cover mr-4"
                  /> */}
                  <CircleUserRound className="size-10 me-4 p-2 text-gold bg-gold/20 rounded-full" />
                  <div>
                    <div className="font-bold text-gray-400">
                      Amanda Rodriguez
                    </div>
                    <div className="text-gray-500 text-sm">
                      Marketing Director, Global Retail Solutions
                    </div>
                  </div>
                </div>
              </blockquote>
            </div>
          </motion.div>
        </div>
      </section>
    </>
  );
};

function ColourfulText({ text }) {
  const colors = [
    "rgb(197, 174, 122)",
    "rgb(197, 174, 122)",
    "rgb(197, 174, 122)",
    "rgb(197, 174, 122)",
    "rgb(197, 174, 122)",
    "rgb(197, 174, 122)",
    "rgb(197, 174, 122)",
    "rgb(197, 174, 122)",
    "rgb(197, 174, 122)",
    "rgb(197, 174, 122)",
  ];

  const [currentColors, setCurrentColors] = useState(colors);
  const [count, setCount] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      const shuffled = [...colors].sort(() => Math.random() - 0.5);
      setCurrentColors(shuffled);
      setCount((prev) => prev + 1);
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  return (
    <>
      {text.split("").map((char, index) => (
        <motion.span
          key={`${char}-${count}-${index}`}
          initial={{
            y: 0,
          }}
          animate={{
            color: currentColors[index % currentColors.length],
            y: [0, -3, 0],
            scale: [1, 1.01, 1],
            filter: ["blur(0px)", `blur(5px)`, "blur(0px)"],
            opacity: [1, 0.8, 1],
          }}
          transition={{
            duration: 0.5,
            delay: index * 0.05,
          }}
          className="inline-block whitespace-pre font-sans tracking-tight"
        >
          {char}
        </motion.span>
      ))}
    </>
  );
}

export default Home;
